export enum PAGE_STATE_ENUM {
    HOVERBOARD = "hoverboard",
    FORMSCREEN = "form",
    PAYMENT = "payment",
    CONFORMATION = "confirm",
}   